import { lazy } from "react";

const RatingCustomerListPage = lazy(() => import("./main"));
const UpdateRatingCustomerPage = lazy(() => import("./update"));

export { RatingCustomerListPage, UpdateRatingCustomerPage };
